export const fedfUploadAnlage = {
  formdefinition: [
    {
      control: "upload",
      name: "anlage",
      label: "Anlage",
      cols: "12",
      add_description: true,
      add_used_in: true,
      multiple: true,
      valid: "isNotEmpty(item)",
    },
    {
      control: "switch",
      name: "intern",
      label: "intern (für VN nicht sichtbar)",
      cols: "12",
      default: false,
    } /*
    {
      control: "switch",
      name: "create_kommunikation",
      label: "Kommunikation erstellen",
      cols: "6",
      default: false,
    },
    {
      control: "switch",
      name: "erinnerung",
      label: "Erinnerung",
      cols: "6",
      default: false,
    },
    {
      control: "datepicker",
      name: "faellig_am",
      label: "Datum der Fälligkeit",
      disabled: "isEqualOther('erinnerung', false)",
      valid: "isNotEmpty(item)",
      cols: "6",
    },*/,
  ],
  transformOut: [],
};
